import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './SubNav.css';

function SubNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e, path) => {
    e.preventDefault();
    if (path) {
      navigate(path);
    }
  };

  return (
    <div className="sub-nav-container">
      <ul className="sub-nav">
        <li className="rs-new-badge"><a href="/logistics/summary" onClick={(e) => handleClick(e)}>물류 요약보기</a></li>
        <li><a href="/products/manage" onClick={(e) => handleClick(e)}>상품 공급상태 관리</a></li>
        <li><a href="/scm/milkrun" onClick={(e) => handleClick(e)}>밀크런</a></li>
        <li><a href="/scm/purchase/order" onClick={(e) => handleClick(e)}>발주-입고 스케줄</a></li>
        <li><a href="/scm/joint/planning" onClick={(e) => handleClick(e)}>공동 발주 플래닝</a></li>
        <li className={location.pathname === '/scm/order/list' ? 'active' : ''}>
          <a href="/scm/order/list" onClick={(e) => handleClick(e, '/scm/order/list')}>발주리스트</a>
        </li>
        <li><a href="/scm/sku/list" onClick={(e) => handleClick(e)}>발주 SKU 리스트</a></li>
        <li><a href="/scm/shipment" onClick={(e) => handleClick(e)}>쉽먼트</a></li>
        <li><a href="/scm/outbound/list" onClick={(e) => handleClick(e)}>반출리스트</a></li>
        <li className={location.pathname === '/scm/receive/detail' ? 'active' : ''}>
          <a href="/scm/receive/detail" onClick={(e) => handleClick(e, '/scm/receive/detail')}>입고 상세내역</a>
        </li>
        <li><a href="/scm/replacement" onClick={(e) => handleClick(e)}>교품</a></li>
        <li className="rs-new-badge"><a href="/commitment/system" onClick={(e) => handleClick(e)}>커미트먼트 시스템</a></li>
      </ul>
    </div>
  );
}

export default SubNav;
